import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'h3-root',
  templateUrl: './app.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  title = 'Sama Workspace';
}
